import "@/components/brand/brand.css";
import { Hero, Palette, Logos } from "@/components/brand/BrandSections";
import { DashboardMock, MobileMock, LabelMock } from "@/components/brand/BrandMockups";
import { GrotalisLogo } from "@/components/brand/Logo";

export default function BrandPreview() {
  return (
    <div className="grotalis min-h-screen" data-testid="brand-preview-page">
      <Hero />
      <Palette />
      <Logos />
      <DashboardMock />
      <MobileMock />
      <LabelMock />
      <footer className="py-12" style={{ background: "var(--g-obsidian)" }}>
        <div className="max-w-6xl mx-auto px-6 sm:px-10 flex flex-wrap items-center justify-between gap-4">
          <GrotalisLogo size={28} />
          <p className="text-xs" style={{ color: "var(--g-stone)" }}>Proposal for review — the live app keeps its current look until approved.</p>
        </div>
      </footer>
    </div>
  );
}
